import * as React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import SignoutOidc from "../oidcClient/signout-oidc";
import SigninOidc from "../oidcClient/signin-oidc";
import SilentSigninOidc from "../oidcClient/silent-signin-oidc";
import Inbox from "../components/Message/Inbox";
import Sent from "../components/Message/Sent";
import Spam from "../components/Message/Spam";
import AuthMethodDialog from "src/components/AuthMethod/AuthMethodDialog";
import Archive from "src/components/Folders/Archive";
import MySettings from "src/components/MySettings/MySettings";
import { Unlock } from "src/components/Unlock/Unlock";
import { MoveFolderModal } from "src/components/Common/MoveToFolder/MoveFolderModal";
import ComposeModal from "src/components/Compose/ComposeModal/ComposeModal";
import InboxLayout from "src/components/Layout/InboxLayout/Layout";
import Login from "src/components/Login";
import LoggedIn from "./LoggedIn";
import LoggedOut from "./LoggedOut";
import ComposeLayout from "src/components/Layout/ComposeLayout/Layout";
import PreLogin from "src/components/PreLogin";
import OutOfOffice from "src/OutOfOffice";
import RestrictedAccess from "src/components/RestrictedAccess";
import SentItemHistory from "src/components/reports/SentItemHistory";
import Support from "src/components/Support/Support";
import ReceiveItemHistory from "src/components/reports/ReceiveItemHistory";
import ComposeLanding from "src/components/Layout/ComposeLanding/ComposeLanding";
import { ComposeDocumentRequest } from "src/components/Layout/ComposeDR/ComposeDocumentRequest";
import { DocumentRequest } from "src/components/RequestDocuments/DocumentRequest";
import { PreviewUplodedFileModal } from "src/components/Preview/PreviewUploadedFileModal";
import SignInPage from "src/components/SignInPage";
import Logout from "src/components/Logout";
import SettingsContainer from "src/components/AdminSettings/AdminSettingsContainer";
import DocumentRequestHistory from "src/components/reports/DocumentRequestHistory";

const AppRoutes: React.FC = () => {
    return (
        <>
            <Routes>
                <Route path="/restricted-access/:message" element={<RestrictedAccess />} />
            </Routes>
            <LoggedIn>
                <Routes>
                    <Route
                        element={
                            <InboxLayout>
                                <Outlet />
                            </InboxLayout>
                        }
                    >
                        <Route path="/" element={<Inbox />} />
                        <Route path="/sent" element={<Sent />} />
                        <Route path="/spam" element={<Spam />} />
                        <Route path="/MyFiles" element={<Archive />} />
                        <Route path="/request-documents" element={<DocumentRequest />} />
                    </Route>
                    <Route
                        path="/preview/:fileName/:fileGuid/:fileType/:requestedYear/:resourceId"
                        element={<PreviewUplodedFileModal />}
                    />
                    <Route path="/settings/*" element={<SettingsContainer />} />
                    <Route path="/my-settings/*" element={<MySettings />} />
                    <Route path="/unlock" element={<Unlock />} />
                    <Route path="/move-to/:folderType/:isMovingFolder/:isDocumentRequest" element={<MoveFolderModal />} />
                    <Route path="/sent-item-history" element={<SentItemHistory />} />
                    <Route path="/support" element={<Support />} />
                    <Route path="/receive-item-history" element={<ReceiveItemHistory />} />
                    <Route path="/document-request-history" element={<DocumentRequestHistory />} />
                </Routes>
                <Routes>
                    <Route path="/compose" element={<ComposeLanding />} />
                    <Route path="/compose-message" element={<ComposeLayout />} />
                    <Route path="/compose-dr" element={<ComposeDocumentRequest />} />
                    <Route path="/compose/auth-method" element={<AuthMethodDialog />} />
                    <Route path="/reply/:messageActionType/:folderType" element={<ComposeModal />} />                    
                </Routes>
            </LoggedIn>

            <LoggedOut>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/signin-oidc" element={<SigninOidc />} />
                    <Route path="/silent-signin-oidc" element={<SilentSigninOidc />} />
                    <Route path="/signout-callback-oidc" element={<SignoutOidc />} />
                    <Route path="/commands" element={<OutOfOffice />} />
                    <Route path="/signin-page" element={<SignInPage />} />
                    <Route path="*" element={<PreLogin />} />
                    <Route path="/logout" element={<Logout />} />
                </Routes>
            </LoggedOut>
        </>
    );
};

export default AppRoutes;
